import { ChangeEvent, useEffect } from "react";
import { Formik, FormikInsured, Gender } from "src/types";
import {
  useFcQuestionOptions,
  useGenderOptions,
  useNationalityOptions,
} from "../../../../handlers/form-label-mapping.hook";
import { useTranslation } from "react-i18next";

export function useInsured({
  formik,
  base,
  onIdentificationFieldsChanges,
}: {
  formik: Formik<any>;
  base: string;
  onIdentificationFieldsChanges?: (insured: FormikInsured) => void;
}) {
  const { setFieldValue, setFieldError, setFieldTouched, values } = formik;

  const { t } = useTranslation();

  const { nationalityOptions } = useNationalityOptions();

  const { fcQuestionOptions } = useFcQuestionOptions();

  const { genderOptions } = useGenderOptions();

  // InsuredFcQuestion  =============================================
  // Handles logic when the user switches the FC question.
  // Reset error and touched object
  const onSelectFcQuestion = (event: ChangeEvent<HTMLInputElement>) => {
    const InsuredFcQuestion = event.target.value;
    if (!InsuredFcQuestion) return;

    const resetFields = [
      `${base}insuredBirth`,
      `${base}insuredBirthNation`,
      `${base}insuredBirthPlace`,
      `${base}insuredGender`,
      `${base}insuredFc`,
    ];

    resetFields.forEach((field) => {
      setFieldValue(field, "");
      setFieldError(field, "");
      setFieldTouched(field, false, false);
    });

    setFieldValue(`${base}insuredGender`, Gender.M);
  };

  useEffect(() => {
    onIdentificationFieldsChanges?.(formik.values);
  }, [formik.values]);

  return {
    t,
    genderOptions,
    fcQuestionOptions,
    nationalityOptions,
    onSelectFcQuestion,
  };
}
